<template>
  <div class="homepage-view">
    <!-- Hero/Slider Section -->
    <section class="section section--slider">
      <hero />
    </section>

    <!-- Booking Engine Section (authenticated users) -->
    <section class="section section--booking-engine" v-if="is_authenticated()">
      <b-container>
        <booking-engine @search="handleSearch" />
      </b-container>
    </section>

    <token-expired
      class="section section--token-expired"
      v-if="!is_authenticated()"
    ></token-expired>

    <sections brand="liveflight" :authenticated="is_authenticated()" />
  </div>
</template>

<script>
import Vue from "vue";
import BookingEngine from "@liveflight/components/blocks/booking-engine/booking-engine";
import Hero from "@/components/blocks/hero.vue";
import TokenExpired from "@/components/blocks/token-expired.vue";
import Sections from "@/components/blocks/sections/sections.vue";
import { is_authenticated } from "@/utilities/";
import { remove_all_filters } from "@liveflight/utilities";

export default {
  name: "homepage-view",
  components: {
    hero: Hero,
    sections: Sections,
    "token-expired": TokenExpired,
    "booking-engine": BookingEngine,
  },
  data() {
    return {
      config: Vue.prototype.$config,
      title_request_form: "Richiedi l'accesso per vedere le disponibilità live",
      subtitle_request_form:
        "Ti invieremo un codice per navigare il sito e cercare il tuo volo. Per prenotare con il credito welfare dovrai comunque fare accesso passando dal tuo portale welfare.",
      site: Vue.prototype.$config.site,
    };
  },
  created() {
    this.is_authenticated = is_authenticated;
  },
  mounted() {
    // Search should clean filter states
    this.remove_all_filters();
  },
  methods: {
    remove_all_filters,
    handleSearch() {
      // Search should clean filter states
      this.remove_all_filters();
      this.$router.push({ name: "results" });
    },
  },
};
</script>

<style lang="scss" scoped>
.homepage-view {
  .section {
    &--slider {
      position: relative;
      margin-top: 0;
    }

    &--booking-engine {
      position: relative;
      z-index: 1;

      @include media-breakpoint-up(md) {
        margin-top: -100px;
      }
    }

    &--brands {
      margin-top: $grid-gutter-width * 2;
    }

    &--bullets {
      margin-top: $grid-gutter-width * 2;
      padding-top: $grid-gutter-width;

      &-item {
        display: block;
        text-align: center;
        padding: 0;
        margin-top: $grid-gutter-width / 2;

        @include media-breakpoint-up(md) {
          margin-top: 0;
        }
      }

      &-icon {
        display: inline-block;
        background: var(--primary);
        padding: 25px;
        border-radius: 100px;

        ::v-deep svg {
          width: 80px;
          height: 80px;
          fill: $white;
        }
      }

      &-text {
        font-weight: $vb-font-weight-semibold;
        font-size: 24px;
        margin-top: 10px;
        line-height: normal;
        color: var(--text);
      }
    }

    &--welfare {
      margin-top: $grid-gutter-width * 4;

      &-content {
        padding-right: $grid-gutter-width;

        @include media-breakpoint-down(sm) {
          padding-right: 0;
          padding-bottom: $grid-gutter-width;
        }
      }

      &-title {
        font-size: 30px;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: $grid-gutter-width;
      }

      &-text {
        font-size: 16px;
        line-height: 1.6;
      }

      &-image {
        width: 100%;
        border-radius: 0;
      }
    }

    &--voucher {
      margin-top: $grid-gutter-width * 4;
      background-color: var(--light-gray-blue);
      padding: $grid-gutter-width * 2;
      text-align: center;
      position: relative;

      &-icon {
        display: inline-block;
        background: $white;
        padding: 10px;
        border-radius: 100px;
        border: 1px solid var(--light-gray);
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);

        ::v-deep svg {
          width: 50px;
          height: 50px;
          fill: var(--primary);
        }
      }

      &-title {
        font-size: 30px;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: $grid-gutter-width;
      }

      &-text {
        font-size: 16px;
        margin-bottom: $grid-gutter-width;
      }

      .btn {
        min-width: 200px;
      }
    }

    &--form {
      margin-top: $grid-gutter-width * 4;
      text-align: center;
      position: relative;

      &-icon {
        display: inline-block;
        background: $white;
        padding: 10px;
        border-radius: 100px;
        border: 1px solid var(--light-gray);
        margin-bottom: $grid-gutter-width;

        ::v-deep svg {
          width: 50px;
          height: 50px;
          fill: var(--primary);
        }
      }

      &-title {
        font-size: 30px;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: $grid-gutter-width / 2;
      }

      &-text {
        font-size: 16px;
        margin-bottom: $grid-gutter-width;
      }
    }

    &--contact {
      margin-top: $grid-gutter-width * 4;
      margin-bottom: $grid-gutter-width * 4;
      text-align: center;
      position: relative;

      &-icon {
        display: inline-block;
        background: $white;
        padding: 10px;
        border-radius: 100px;
        border: 1px solid var(--light-gray);
        margin-bottom: $grid-gutter-width;

        ::v-deep svg {
          width: 50px;
          height: 50px;
          fill: var(--primary);
        }
      }

      &-title {
        font-size: 30px;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: $grid-gutter-width / 2;
      }

      &-text {
        font-size: 16px;
      }
    }
  }
}
</style>
